import { selectFromRoutePaginatedDto, selectFromRouteDto } from '../../models';

// The minimal field set for the nav's unpublished-routes badge: just what
// `isPublishableRoute` reads (isDispatched, unpublishedChanges, stopsCount,
// active solution finished). `hasPublishablePendingChanges` reads that flag
// directly, so a completed route drops out even when the published-routes
// toggle is on. Plus the identity fields mst-gql needs to normalize the
// route and `name`, which `sortedRoutesByDay` filters on.
const RoutePublishStatusQuery = selectFromRouteDto()
  .uuid
  .name
  .startDate
  .projectId
  .isDispatched
  .unpublishedChanges
  .activeRouteSolution(routeSolution => routeSolution.id.stopsCount.finished);

export default selectFromRoutePaginatedDto()
  .hasNextPage
  .edges(b => b.node(RoutePublishStatusQuery))
  .toString();
